import {TrackingEvents} from 'web-app/util/famlytics/events';
import {track} from 'web-app/util/famlytics/index';

type NewPlanSavedArgs = {
    childrenAmount: number;
    tuition: number;
    fee: number;
    automaticBilling: string;
    firstBillingPeriod: boolean | string;
    discount: number;
    endDate: boolean;
    planTemplateSaved: boolean;
};

const newPlanSaved = (args: NewPlanSavedArgs) => {
    track(TrackingEvents.NEW_PLAN_SAVED, {
        ...args,
    });
};

const newPlanModalCanceled = () => track(TrackingEvents.NEW_PLAN_MODAL_CANCELED);

const newPlanModalMoreOptions = () => track(TrackingEvents.NEW_PLAN_MODAL_MORE_OPTIONS);

const newPlanModalAddTuition = () => track(TrackingEvents.NEW_PLAN_MODAL_ADD_TUITION);

const newPlanModalAddFee = () => track(TrackingEvents.NEW_PLAN_MODAL_ADD_FEE);

const newPlanModalCustomPeriodSelected = () => track(TrackingEvents.NEW_PLAN_MODAL_CUSTOM_PERIOD_SELECTED);

const newPlanCustomPeriodSaved = () => track(TrackingEvents.NEW_PLAN_CUSTOM_PERIOD_SAVED);

const newPlanCustomPeriodAmount = () => track(TrackingEvents.NEW_PLAN_CUSTOM_PERIOD_AMOUNT);

type NewPlanAddNewSavedArgs = {
    type: 'tuition' | 'fee' | 'discount';
    addToLibrary: boolean;
    allPricingGroups: boolean;
};
const newPlanAddNewSaved = (args: NewPlanAddNewSavedArgs) => track(TrackingEvents.NEW_PLAN_ADD_NEW_SAVED, {...args});

const newPlanSaveOverridePrice = () => track(TrackingEvents.NEW_PLAN_SAVE_OVERRIDE_PRICE);

const startFromScratch = () => track(TrackingEvents.START_FROM_SCRATCH);

const templatePicked = () => track(TrackingEvents.TEMPLATE_PICKED);

export const editPlanSaved = () => track(TrackingEvents.EDIT_PLAN_SAVED);

type OpenGlobalPlanModalFromChillBillOrigin = 'unsupported plan button' | 'more options link' | 'fully billed button';

export const openGlobalPlanModalFromChillBill = (origin: OpenGlobalPlanModalFromChillBillOrigin) =>
    track(TrackingEvents.OPEN_GLOBAL_PLAN_MODAL_FROM_CHILL_BILL, {
        origin,
    });

export {
    newPlanSaved,
    newPlanModalCanceled,
    newPlanModalMoreOptions,
    newPlanModalAddTuition,
    newPlanModalAddFee,
    newPlanModalCustomPeriodSelected,
    newPlanCustomPeriodSaved,
    newPlanCustomPeriodAmount,
    newPlanAddNewSaved,
    newPlanSaveOverridePrice,
    startFromScratch,
    templatePicked,
};
